import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { api } from '../lib/api';

export default function Confirmation() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.getOrder(orderId).then(setOrder).catch(() => setError(true));
  }, [orderId]);

  if (error) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-24 text-center">
        <p className="text-stone-500 mb-4">Pedido no encontrado.</p>
        <Link to="/tienda" className="text-teal-600 font-bold">Ir a la tienda</Link>
      </div>
    );
  }

  if (!order) return <div className="max-w-7xl mx-auto px-4 py-24 text-center text-stone-400">Cargando…</div>;

  return (
    <div className="max-w-2xl mx-auto px-4 py-16 text-center" data-testid="confirmation-page">
      <CheckCircle2 className="w-16 h-16 text-teal-500 mx-auto mb-5" />
      <h1 className="text-3xl font-black text-stone-800 mb-2">¡Gracias por tu compra!</h1>
      <p className="text-stone-500 mb-8">Tu pedido <strong data-testid="confirmation-order-id">{order.id}</strong> se ha registrado correctamente. Recibirás la confirmación en <strong>{order.customer.email}</strong>.</p>

      <div className="bg-white border border-stone-200 rounded-lg p-6 text-left mb-8">
        <h2 className="font-black text-stone-800 mb-4">Resumen</h2>
        {order.items.map((i, idx) => (
          <div key={idx} className="flex justify-between text-sm text-stone-600 mb-2">
            <span>{i.name} ×{i.qty}</span>
            <span>{(i.price * i.qty).toFixed(2).replace('.', ',')} €</span>
          </div>
        ))}
        <div className="border-t border-stone-200 mt-4 pt-4 flex justify-between font-black text-stone-800">
          <span>Total pagado</span><span>{order.total.toFixed(2).replace('.', ',')} €</span>
        </div>
        {order.legalSnapshot && Object.keys(order.legalSnapshot).length > 0 && (
          <p className="text-[11px] text-stone-400 mt-4">Condiciones aceptadas: {Object.entries(order.legalSnapshot).map(([k, v]) => `${k} ${v}`).join(' · ')}</p>
        )}
      </div>

      <div className="bg-teal-50 border border-teal-200 rounded-lg p-5 text-sm text-teal-800 mb-8">
        <strong>Siguiente paso:</strong> tu formación se gestiona en <strong>app.naturautoescuela.es</strong>. Recibirás tus accesos por email.
      </div>

      <Link to="/tienda" className="btn-natur inline-flex items-center gap-2 px-8 py-3 rounded font-bold text-sm" data-testid="back-to-shop">
        Seguir comprando <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  );
}
